import axios from 'axios';

export const ApiADA = axios.create({
    baseURL: 'https://ada.tec.br/clientes/integrador-codapta-clientes',
    headers: {'Content-Type': 'application/json', 'access_key': '&%4b4be07f44f52c804d20a5da8f82cefd$*@'},
    timeout: 15000,
})

export const ApiBackClient = axios.create({
    //Na função de login que fica no contexto Auth, é salvo no localstorage a base_url
    headers: {'Content-Type': 'application/json'},
    timeout: 60000
})

export const ApiCEP = axios.create({
    baseURL: 'https://viacep.com.br/ws',
    headers: {'Content-Type': 'application/json'},
    timeout: 15000,
})